// extracted by mini-css-extract-plugin
export default {"caption":"Tittle_caption__9BpOe"};